import React, { Fragment, useCallback, useEffect, useState } from "react";
import { GET_TNA_SUMMAARY_DETAILS } from "apiServices/API_ENDPOINTS";
import { useParams, Link } from "react-router-dom";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { Affix, Card, Space, Button, Spin } from "antd";
import Header from "components/Common/Header";
import { isMobileView } from "components/Common/AppHelper";
import { cglFormatDate } from "utils/functions";
import "./summaryView.css";

const SummaryView = ({ width }) => {
  const { summaryId } = useParams();
  const [taskList, setTaskList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAllPermitList = useCallback(async () => {
    setLoading(true);
    let response = await getData(
      `${GET_TNA_SUMMAARY_DETAILS}/${summaryId}/details`,
      false,
    );

    if (response && response?.data?.code === 200) {
      const masterData = response?.data?.data;
      setTaskList(masterData?.plan_tasks || []);
    } else {
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    getAllPermitList();
  }, [getAllPermitList]);

  const getStatusStyle = (status) => {
    return {
      backgroundColor:
        status === "Regular"
          ? "#93cddd"
          : status === "Overdue"
          ? "#f66d6d"
          : "#ffc000",
      color:
        status === "Regular"
          ? "#045b73"
          : status === "Overdue"
          ? "#0f0f0f"
          : "#9f7803",
      border: "2px solid white",
      padding: "4px",
      textAlign: "center",
      wordWrap: "break-word",
      borderRadius: "4px",
      fontWeight: "500",
      display: "block",
    };
  };

  const renderTaskRows = (tasks) => {
    if (!tasks || tasks.length === 0) return null;

    let rows = [];

    tasks.forEach((task, index) => {
      const taskDate =
        task.task_dates && task.task_dates.length > 0
          ? task.task_dates[0]
          : null;

      if (!taskDate) return;

      let stylesCount = 0;
      let poCount = 0;

      if (
        task.relation_with === "Style" &&
        taskDate.styles &&
        taskDate.styles.length > 0
      ) {
        stylesCount = taskDate.styles.length;
      }

      if (
        task.relation_with === "PO" &&
        taskDate.purchase_order_maps &&
        taskDate.purchase_order_maps.length > 0
      ) {
        poCount = taskDate.purchase_order_maps.length;
      }

      const rowspan = Math.max(1, stylesCount, poCount);

      if (rowspan === 1) {
        rows.push(
          <tr key={`task-${task.id}`}>
            <td>{index + 1}</td>
            <td>{task.title}</td>
            <td>{task.process}</td>
            <td>{task.department}</td>
            <td>
              {task.relation_with === "Style" && taskDate.styles
                ? taskDate.styles.map((style) => style.style_no).join(", ")
                : "N/A"}
            </td>
            <td>
              {task.relation_with === "PO" && taskDate.purchase_order_maps
                ? taskDate.purchase_order_maps
                    .map((po) => po.original_po)
                    .join(", ")
                : "N/A"}
            </td>
            <td>{cglFormatDate(taskDate.due_date)}</td>
            <td>{cglFormatDate(taskDate.action_status_date) || "N/A"}</td>
            <td>{taskDate.variance}</td>
            <td>{taskDate.action_status_string || "N/A"}</td>
            <td>
              <div style={getStatusStyle(taskDate.status)}>
                {taskDate.status || "N/A"}
              </div>
            </td>
            <td>{task.responsible_person_name || "N/A"}</td>
            <td>
              {task.task_dependencies && task.task_dependencies.length > 0
                ? task.task_dependencies.map((dep) => dep.title).join(", ")
                : "N/A"}
            </td>
          </tr>,
        );
      } else {
        rows.push(
          <tr key={`task-${task.id}-row-0`}>
            <td rowSpan={rowspan}>{index + 1}</td>
            <td rowSpan={rowspan}>{task.title}</td>
            <td rowSpan={rowspan}>{task.process}</td>
            <td rowSpan={rowspan}>{task.department}</td>
            <td>
              {task.relation_with === "Style" &&
              taskDate.styles &&
              taskDate.styles.length > 0
                ? taskDate.styles[0].style_no
                : "N/A"}
            </td>
            <td>
              {task.relation_with === "PO" &&
              taskDate.purchase_order_maps &&
              taskDate.purchase_order_maps.length > 0
                ? taskDate.purchase_order_maps[0].original_po
                : "N/A"}
            </td>
            <td rowSpan={rowspan}>{cglFormatDate(taskDate.due_date)}</td>
            <td rowSpan={rowspan}>
              {cglFormatDate(taskDate.action_status_date) || "N/A"}
            </td>
            <td rowSpan={rowspan}>{taskDate.variance}</td>
            <td rowSpan={rowspan}>{taskDate.action_status_string || "N/A"}</td>
            <td rowSpan={rowspan}>
              <div style={getStatusStyle(taskDate.status)}>
                {taskDate.status || "N/A"}
              </div>
            </td>
            <td rowSpan={rowspan}>{task.responsible_person_name || "N/A"}</td>
            <td rowSpan={rowspan}>
              {task.task_dependencies && task.task_dependencies.length > 0
                ? task.task_dependencies.map((dep) => dep.title).join(", ")
                : "N/A"}
            </td>
          </tr>,
        );

        if (task.relation_with === "Style" && taskDate.styles) {
          for (let i = 1; i < taskDate.styles.length; i++) {
            rows.push(
              <tr key={`task-${task.id}-style-${i}`}>
                <td>{taskDate.styles[i].style_no}</td>
                <td>N/A</td>
              </tr>,
            );
          }
        } else if (
          task.relation_with === "PO" &&
          taskDate.purchase_order_maps
        ) {
          for (let i = 1; i < taskDate.purchase_order_maps.length; i++) {
            rows.push(
              <tr key={`task-${task.id}-po-${i}`}>
                <td>N/A</td>
                <td>{taskDate.purchase_order_maps[i].original_po}</td>
              </tr>,
            );
          }
        }
      }
    });

    return rows;
  };

  const extra = (
    <Space>
      <Button type={"primary"} size="small" style={{ float: "right" }}>
        <Link to={`/tanda/summary`}>Back to List</Link>
      </Button>
    </Space>
  );

  return (
    <div className="mt-4" style={{ width: "100%" }}>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{
            width: "100%",
            boxShadow: "none",
          }}
        >
          <Header title="T&A Summary Details" subTitle="" actions={extra} />
        </Card>
      </Affix>

      {loading ? (
        <div className="loading-container">
          <Spin size="large" />
        </div>
      ) : (
        <div
          className="todo-table"
          style={{
            padding: "5px 0",
            maxHeight: "calc(100vh)",
            overflowY: "auto",
            backgroundColor: "white",
            width: "100%",
            overflowX: "auto",
            display: "block",
          }}
        >
          <table
            style={{
              width: "100%",
              tableLayout: "fixed",
              borderCollapse: "collapse",
              minWidth: "100%",
            }}
          >
            <colgroup>
              <col style={{ width: "3%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "7%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
            </colgroup>
            <thead>
              <tr style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <th className="t-header bc-java">Sl</th>
                <th className="t-header bc-java">Task</th>
                <th className="t-header bc-java">Process</th>
                <th className="t-header bc-java">Department</th>
                <th className="t-header bc-java">Style(s)</th>
                <th className="t-header bc-java">PO(s)</th>
                <th className="t-header bc-java">Due Date</th>
                <th className="t-header bc-java">Actual Date</th>
                <th className="t-header bc-java">Variance (Days)</th>
                <th className="t-header bc-java">Action</th>
                <th className="t-header bc-java">Status</th>
                <th className="t-header bc-java">Responsible</th>
                <th className="t-header bc-java">Dependency</th>
              </tr>
            </thead>
            <tbody>
              {taskList.length > 0 ? (
                renderTaskRows(taskList)
              ) : (
                <tr>
                  <td colSpan="13" className="no-data">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SummaryView;
